import {Injectable} from '@angular/core';
import {EMPTY, Observable, Subject} from "rxjs";
import {map} from 'rxjs/operators';
import {environment} from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import * as Cookies from 'js-cookie';
import {ConstantsService, ConstantsService as constants} from '../constants/constants.service';
import {JwtHelperService} from '@auth0/angular-jwt';


//TODO: Remove Backwards compatibility with ENT-9105 FF removal
@Injectable({
  providedIn: 'root'
})
export class IdService {

  idApi = `${environment.ID_API}`;
  loggingOut = false;
  unauthenticated$ = new Subject<string>();
  constructor(private http: HttpClient, private jwtHelper: JwtHelperService) {}

  updatePassword(passwords: any): Observable<any> {
    const endpoint = this.idApi + 'update-password';
    return this.http.put(endpoint, passwords).pipe(map(res => res['data']));
  }

  deprecatedSwitchOrgs(newOrgUuid): Observable<any> {
    const endpoint = this.idApi + 'refresh';
    const refreshToken = environment.use_global_id ? Cookies.get(constants.REFRESH_TOKEN) : Cookies.get(constants.DEPRECATED_REFRESH_TOKEN);

    return this.http.post(endpoint, {'refresh': refreshToken, 'uuid': newOrgUuid, 'platform': 'xsp'}, { withCredentials: true }).pipe(map(res => res));
  }

  switchOrgs(newOrgUuid): Observable<any> {
    const endpoint = this.idApi + 'refresh';
    const xref_id =Cookies.get(constants.XREF_ID);

    return this.http.post(endpoint, {'xref_id': xref_id, 'uuid': newOrgUuid, 'platform': 'xsp'}, { withCredentials: true }).pipe(map(res => res));
  }

  getActiveFlags(){
      return this.http.get(`${this.idApi}feature-flags`);
  }

  redirectToLogin() {
    location.assign(`${environment.LOGIN_URL}?retUrl=${encodeURIComponent(location.href)}`);
  }

  removeToken() {
    sessionStorage.removeItem(`${ConstantsService.AUTH_TOKEN}`);
    Cookies.remove(`${ConstantsService.XREF_ID}`, {domain: environment.COOKIE_DOMAIN});
    Cookies.remove(`${ConstantsService.XREF_PLATFORM}`, {domain: environment.COOKIE_DOMAIN});
    Cookies.remove(`${ConstantsService.AUTH_TOKEN}`, {domain: environment.COOKIE_DOMAIN});
    Cookies.remove(`${ConstantsService.REFRESH_TOKEN}`, {domain: environment.COOKIE_DOMAIN});
    this.unauthenticated$.next("undefined");
  }

  logout(): void {
    // Remove token
    this.removeToken();

    // Reset all filters and search when logging out
    localStorage.removeItem("backGroundCheck_filters");
    localStorage.removeItem("backGroundCheck_search");
    localStorage.removeItem("exit_filters");
    localStorage.removeItem("exit_search");
    localStorage.removeItem("pulse_filters");
    localStorage.removeItem("pulse_search");
    localStorage.removeItem("reference_filters");
    localStorage.removeItem("reference_search");
    localStorage.removeItem("requests-filter");

    if (!this.loggingOut) this.redirectToLogin();

    this.loggingOut = true;
  }


  loggedIn() {
    return Cookies.get(constants.XREF_ID) != undefined || Cookies.get(constants.REFRESH_TOKEN) != undefined;
  }


  getAuthToken() {
    if(!this.loggedIn()) {
      this.logout();
    }

    let token = sessionStorage.getItem(ConstantsService.AUTH_TOKEN) || Cookies.get(constants.AUTH_TOKEN) || "";

    if(!token || this.jwtHelper.isTokenExpired(token)) {
      const apiRegion = Cookies.get(ConstantsService.API_REGION_TOKEN);
      let selectedOrgUid = Cookies.get(constants.ORG_COOKIE);
      this.refreshToken(selectedOrgUid, apiRegion);
      token = sessionStorage.getItem(ConstantsService.AUTH_TOKEN) || "";
    }


    if (token == null) {
      this.logout();
      return EMPTY;
    }

    return token;
  }

  refreshToken(org_uid: any, region: any, callback?: any) {

    if (!sessionStorage.getItem(ConstantsService.AUTH_TOKEN) ||
      this.jwtHelper.isTokenExpired(sessionStorage.getItem(ConstantsService.AUTH_TOKEN))) {

        const req = new XMLHttpRequest();
        req.open('POST', `${this.idApi}refresh`, false);
        req.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        req.setRequestHeader('Accept', 'application/json');

        req.onload = function () {

            if (req.status === 200) {
            // Set new token as cookie
            const data = JSON.parse(req.response);
            Cookies.set(constants.XREF_ID, data['xref_id'], {domain: environment.COOKIE_DOMAIN});
            sessionStorage.setItem(constants.AUTH_TOKEN, data['access']);
            Cookies.set(constants.API_REGION_TOKEN, data['region'], {domain: environment.COOKIE_DOMAIN});
            Cookies.set(constants.ORG_COOKIE, data['organisation'], {domain: environment.COOKIE_DOMAIN});
            if(callback) callback();
          } else if (req.status === 400) {
            if(callback) {
              callback(JSON.parse(req.response));
            } else {
              sessionStorage.removeItem(`${ConstantsService.AUTH_TOKEN}`);
              Cookies.remove(`${ConstantsService.XREF_ID}`, {domain: environment.COOKIE_DOMAIN});
              Cookies.remove(`${ConstantsService.XREF_PLATFORM}`, {domain: environment.COOKIE_DOMAIN});
              location.assign(`${environment.LOGIN_URL}?retUrl=${encodeURIComponent(location.href)}`);
            }

          } else {
            if(callback) callback(new Error());
          }
        };

        req['data'] = {
          'uuid': org_uid,
          'region': region,
          'platform': 'xsp'
        }
        if(Cookies.get(constants.XREF_ID)) {
          req['data']['xref_id'] = Cookies.get(constants.XREF_ID);
        } else {
          req['data']['refresh'] = Cookies.get(constants.REFRESH_TOKEN);
        }
        req.send(JSON.stringify(req['data']));
    }
  }
}
